export default __webpack_public_path__ + "static/media/error.5b8fb57e.gif";